// extracted by mini-css-extract-plugin
module.exports = {"container":"MakeGroupPaymentPageView_container__1ZJPm","section":"MakeGroupPaymentPageView_section__3S83C"};